export const environment = {
  production: false,
  entorno: "Desarrollo",
  buildNumber: 'Dicea-UI_CI-Dicea.UI.Dev_master_20250714.1',
  appInsights: {
    instrumentationKey: '363fa37d-1684-4082-98cb-b43dd9c3f700'
  }
};
